<template>
  <div class="hello">
    <div class="one_oo">高效化企业培训SaaS平台</div>
    <div class="hello_q">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="用户管理" name="1">
          <img src="../assets/HelloWorld/boss_1.png" alt="" style="width: 1200px;">
        </el-tab-pane>
        <el-tab-pane label="配置管理" name="2">
          <img src="../assets/HelloWorld/boss_2.png" alt="" style="width: 1200px;">
        </el-tab-pane>
     </el-tabs>
    </div>

  </div>
</template>

<script>
export default {
  name: "schemeTop",
  data() {
      return {
        activeName: '1'
      };
    },
    methods: {
      handleClick(tab, event) {
        console.log(tab, event);
      }
    }
}
</script>

<style lang="scss" scoped>
.hello {
  width: 1200px;
  height: 1000px;
  margin-top: 80px;
  text-align: center;

  .one_oo{
    font-size: 40px;
    margin-bottom: 32px;
  }
}
::v-deep .el-tabs__header{
margin:0 0  40px;
}
::v-deep .el-tabs__nav{
  width: 100%;
}
::v-deep .el-tabs__active-bar{
  width: 600px !important;
  background: #eb5b05;
}
::v-deep .el-tabs__nav-wrap::after{
  background: transparent;
}
::v-deep .el-tabs__nav-wrap{
  box-shadow: 0 2px 0 0 rgba(0,0,0,.15);
}
::v-deep .el-tabs__item{
  height: 60px;
  line-height: 60px;
  font-size: 22px;
}
::v-deep .el-tabs__item:hover{
  color: #eb5b05;
  background: #fff6f1;
}
::v-deep .el-tabs__item.is-active{
  color: #eb5b05;
  background: #fff6f1;
}
::v-deep .el-tabs--top .el-tabs__item.is-top:last-child{
  text-align: center;
  width: 50%;
  padding: 0;
}
::v-deep .el-tabs--top .el-tabs__item.is-top:nth-child(2){
  text-align: center;

  width: 50%;
  padding: 0;
}
</style>
